import { ADMISSION_TYPE_BOTTLE_SERVICE } from '@domain/admission';
import { BookingFormField } from '@domain/booking-form-field';
import { FormFieldPreset } from '@domain/form-field-presets';

import { filterNewOfferFormFields, mergeFormFields } from './format-ticket-formFields-from-backend';
import { FIELD_EMAIL, FIELD_PHONE } from './validate-import-csv';

interface FormatBookingHolderProps {
  formFields: FormFieldPreset[];
  type?: string;
  isEdit?: boolean;
  isFormFieldDisabled?: boolean;
  includeMinMax?: boolean;
  offerBookingFormFields?: BookingFormField[];
}

export const formFieldPresetToFormField = ({
  formFields,
  type = '',
  isEdit = false,
  isFormFieldDisabled = false,
  includeMinMax = false,
}: Omit<FormatBookingHolderProps, 'offerBookingFormFields'>) => {
  return formFields.map(({ name, slug, dataType, isAssignedByDefault, min, max }) => {
    const baseField = {
      name,
      dataType,
      isRequired: (type === ADMISSION_TYPE_BOTTLE_SERVICE && slug === FIELD_PHONE && !isEdit) || isAssignedByDefault,
      disabled: slug === FIELD_EMAIL || isFormFieldDisabled,
    };

    if (includeMinMax) {
      return {
        ...baseField,
        min,
        max,
      };
    }

    return baseField;
  });
};

export const formatBookingHolderFromBackend = ({
  formFields,
  offerBookingFormFields,
  type = '',
  isEdit = false,
  isFormFieldDisabled = false,
  includeMinMax = false,
}: FormatBookingHolderProps) => {
  const initialBookingformFields = formFieldPresetToFormField({
    formFields,
    type,
    isFormFieldDisabled,
    isEdit,
    includeMinMax,
  });

  const bookingFormFields = mergeFormFields(initialBookingformFields, offerBookingFormFields);

  const newBookingFormFields = filterNewOfferFormFields({
    offerFormFields: offerBookingFormFields,
    initialFormFields: bookingFormFields,
    includeMinMax,
    isFormFieldDisabled,
  });

  return [...bookingFormFields, ...newBookingFormFields];
};
